import { LOADING_WORKSPACES_SHARE_LIST } from './index';

export const loadingWorkspacesShareListAction = (loading) => ({
    type: LOADING_WORKSPACES_SHARE_LIST,
    loading
});